import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';
import dayjs from 'dayjs';

export const PROMOTIONS_FETCH_DATA_INIT = createAction('PROMOTIONS_FETCH_DATA_INIT');
export const PROMOTIONS_FETCH_DATA_SUCCESS = createAction(
  'PROMOTIONS_FETCH_DATA_SUCCESS'
);
export const PROMOTIONS_FETCH_DATA_FAIL = createAction('PROMOTIONS_FETCH_DATA_FAIL');

export const PROMOTIONS_DELETE_PROMOTION_INIT = createAction('PROMOTIONS_DELETE_PROMOTION_INIT');
export const PROMOTIONS_DELETE_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_DELETE_PROMOTION_SUCCESS'
);
export const PROMOTIONS_DELETE_PROMOTION_FAIL = createAction('PROMOTIONS_DELETE_PROMOTION_FAIL');

export const PROMOTIONS_CLEAR_DATA = createAction('PROMOTIONS_CLEAR_DATA');

export const PROMOTIONS_CREATE_PROMOTION_INIT = createAction('PROMOTIONS_CREATE_PROMOTION_INIT');
export const PROMOTIONS_CREATE_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_CREATE_PROMOTION_SUCCESS'
);
export const PROMOTIONS_CREATE_PROMOTION_FAIL = createAction('PROMOTIONS_CREATE_PROMOTION_FAIL');

export const PROMOTIONS_MODIFY_PROMOTION_INIT = createAction('PROMOTIONS_MODIFY_PROMOTION_INIT');
export const PROMOTIONS_MODIFY_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_MODIFY_PROMOTION_SUCCESS'
);
export const PROMOTIONS_MODIFY_PROMOTION_FAIL = createAction('PROMOTIONS_MODIFY_PROMOTION_FAIL');

export const PROMOTIONS_CLEAN_UP = createAction('PROMOTIONS_CLEAN_UP');

export const PROMOTIONS_CLEAR_DATA_LOGOUT = createAction('PROMOTIONS_CLEAR_DATA_LOGOUT');
export const PROMOTIONS_SYNC_PROMOTION_INIT = createAction('PROMOTIONS_SYNC_PROMOTION_INIT');
export const PROMOTIONS_SYNC_PROMOTION_SUCCESS = createAction('PROMOTIONS_SYNC_PROMOTION_SUCCESS');
export const PROMOTIONS_SYNC_PROMOTION_FAIL = createAction('PROMOTIONS_SYNC_PROMOTION_FAIL');

export const fetchPromotion = ({
  promotionId,
  siteId,
  type,
  // categoryId = 'all',
  // type = 'published',
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(PROMOTIONS_FETCH_DATA_INIT());
    if (promotionId) {
      let promotionData;
      try {
        promotionData = await Axios.get(`${url}/promotion/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          params: {
            siteId,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PROMOTIONS_FETCH_DATA_FAIL({ error }));
      }
      const promotionFind = promotionData.data.data.find((x) => x._id === promotionId);
      const promotion = { ...promotionFind, id: promotionId };
      return dispatch(
        PROMOTIONS_FETCH_DATA_SUCCESS({
          list: getState().promotions.list,
          promotion,
        })
      );
    }

    if (siteId) {
      let promotions;
      try {
        promotions = await Axios.post(
          `${url}/promotion/filter`,
          {
            siteId,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(PROMOTIONS_FETCH_DATA_FAIL({ error }));
      }
      promotions = promotions.data.data;
      return dispatch(
        PROMOTIONS_FETCH_DATA_SUCCESS({
          list: promotions,
          promotion: getState().promotions.promotion,
        })
      );
    }
  };
};

export const syncPromotion = () => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_SYNC_PROMOTION_INIT());
    Axios.get(`${url}/promotion/fetch`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
      .then(() => {
        return dispatch(PROMOTIONS_SYNC_PROMOTION_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PROMOTIONS_SYNC_PROMOTION_FAIL({ error }));
      });
  };
};

export const createPromotion = (deal) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_CREATE_PROMOTION_INIT());

    const formData = new FormData();
    formData.set('siteId', deal.siteId);
    formData.set('title', deal.title || deal.Title || '');

    if (deal.description) {
      formData.set('description', deal.description);
    }
    if (deal.status) {
      formData.set('status', deal.status);
    }
    if (deal.uri) {
      formData.set('uri', deal.uri);
    }
    if (deal.link) {
      formData.set('link', deal.link);
    }
    if (deal.dateGmt) {
      formData.set(
        'dateGmt',
        dayjs.isDayjs(deal.dateGmt)
          ? deal.dateGmt.format()
          : dayjs(deal.dateGmt).format()
      );
    }

    // Handle file upload for featuredImage
    if (deal.file) {
      formData.append('file', deal.file);
    }

    try {
      await Axios.post(`${url}/promotion/create`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      toastr.error('', 'Please fill in all required fields');
      return dispatch(
        PROMOTIONS_CREATE_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Deal created successfully');
    return dispatch(PROMOTIONS_CREATE_PROMOTION_SUCCESS({ deal }));
  };
};

export const modifyPromotion = (deal) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_MODIFY_PROMOTION_INIT());

    const formData = new FormData();
    formData.set('id', deal.id || deal._id);
    formData.set('siteId', deal.siteId);
    formData.set('title', deal.title || deal.Title || '');

    if (deal.description) {
      formData.set('description', deal.description);
    }
    if (deal.status) {
      formData.set('status', deal.status);
    }
    if (deal.uri) {
      formData.set('uri', deal.uri);
    }
    if (deal.link) {
      formData.set('link', deal.link);
    }
    if (deal.dateGmt) {
      formData.set(
        'dateGmt',
        dayjs.isDayjs(deal.dateGmt)
          ? deal.dateGmt.format()
          : dayjs(deal.dateGmt).format()
      );
    }

    // Handle featuredImage
    if (deal.file) {
      // New file upload
      formData.append('file', deal.file);
    } else if (deal.featuredImage === null) {
      // Explicitly clear the image
      formData.set('featuredImage', '');
    } else if (deal.featuredImage) {
      // Keep existing image
      formData.set('featuredImage', JSON.stringify(deal.featuredImage));
    }

    try {
      await Axios.put(`${url}/promotion/edit`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PROMOTIONS_MODIFY_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Deal updated successfully');
    return dispatch(PROMOTIONS_MODIFY_PROMOTION_SUCCESS({ deal, id: deal.id || deal._id }));
  };
};

export const deletePromotion = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_DELETE_PROMOTION_INIT());
    try {
      await Axios.post(
        `${url}/promotion/delete`,
        {
          dealId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PROMOTIONS_DELETE_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The deal was deleted.');
    cb();
    return dispatch(PROMOTIONS_DELETE_PROMOTION_SUCCESS({ id }));
  };
};

export const promotionsCleanUp = () => (dispatch) => dispatch(PROMOTIONS_CLEAN_UP());
